import { trackAnalytics, createImgPath } from "@/utils";

export default {
	name: "tile",
	props: {
		data: {
			type: Object,
			required: true,
		},
		index: {
			type: Number,
			required: true,
		},
		section: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			firstImageUrl: '', // Inizializza come stringa vuota
			secondImageUrl: '', // Inizializza come stringa vuota
		};
	},
	async created() {
		// Carica le immagini quando il componente viene creato
		this.firstImageUrl = await this.getImgUrl(this.data.img, this.data.partNumber, 'LiveSearchFirstImage');
		this.secondImageUrl = await this.getImgUrl(this.data.img2, this.data.partNumber, 'LiveSearchSecondImage');
	},
	methods: {
		returnElementId(section) {
			switch (section) {
				case "result":
					return "SearchPanel_Results_tile";
				case "bestseller":
				case "noresult":
				default:
					return "SearchPanel_Content_tile";
			}
		},
		analyticsTiles(productNumber, index) {
			trackAnalytics("Click", "hiddenaction", this.returnElementId(this.section) + index, productNumber);
		},
		addDomain() {
			return "https://" + window.location.hostname;
		},
		async getImgUrl(imgPath, partNumber, contextId) {
			try {
				const url = await createImgPath(imgPath, partNumber, contextId);
				return url || ''; // Fallback a stringa vuota se undefined
			} catch (error) {
				console.error('Error loading image:', error);
				return ''; // Fallback a stringa vuota in caso di errore
			}
		}		
	},
	computed: {
		hasAlternativeImage() {
			// Applica il fade solo se la seconda immagine contiene "_al"
			return this.secondImageUrl && this.secondImageUrl.includes('_al');
		},
	},

};
